@if (!showFullText && !article?.warehouse && showStatus) {
  <span
    class="statusIcon status d-inline-flex align-items-center"
    [ngClass]="[
      article?.call_dealersupport ? 'border border-warning notice mt-2' : '',
      'status_' + (article?.call_dealersupport ? '3' : article?.stock_status),
      'company_' + article?.company_id
    ]"
    [placement]="tooltipPlacement"
    [ngbTooltip]="!showText ? (article | statusText) : null"
    >
    @if (
      showText &&
      (!article?.setitem || (article?.setitem && article?.stock_status < 7))
      ) {
    <span
      class="text"
          >
      @if (article?.matrix?.options?.length && (companyGroupCode === 'ANL' || companyGroupCode === 'LAP')) {
      <span>{{ article?.matrix?.options[0]?.description}} - </span>
      }{{ article | statusText }}</span
>
          }</span
          >
        }
        @if (showFullText && showStatus) {
          <div
            class="status_text"
    [ngClass]="[
      'status_' + article?.stock_status,
      'company_' + article?.company_id
    ]"
            >
            {{ article | statusText }}
          </div>
        }
        @if (article?.warehouse) {
          <span
            class="statusIcon status d-inline-flex align-items-center"
            [ngClass]="['status_' + fastestDelivery?.stock_status]"
            >
            {{ warehouseText }}
          </span>
        }
